import { MenuItem, Box, Select } from '@mui/material';
import { useTranslate } from 'react-admin';
import { InventoryCategoryIconName } from '../../../components/icons/inventoryCategoryIcons';
import { IconField } from '../../../components/fields/IconField';

export const FilterSelector = (props: {
  label: string;
  items: { name: string; _id: string; icon?: InventoryCategoryIconName }[];
  value: string | null;
  onChange: (value: string | null) => void;
}) => {

  const translate = useTranslate();

  return (
    <Box>
      <span className="device-filter-row-label" style={{ display: 'block', marginBottom: 4 }}>
        {props.label}
      </span>
      <Select
        displayEmpty
        fullWidth
        size="small"
        value={props.value ?? ''}
        onChange={(e) => {

          const v = e.target.value as string;
          props.onChange(v === '' ? null : v);

        }}
        sx={{
          height: 35,
          fontSize: 12,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9AB4A3',
          },
        }}
        renderValue={(selected) => {

          if (!selected) {

            return <span style={{ color: '#888' }}>{props.label}</span>;

          }
          return props.items.find((c) => c._id === selected)?.name ?? selected;

        }}
      >
        <MenuItem value="">
          <em>{translate('general.text.all')}</em>
        </MenuItem>
        {props.items.map((item) => (
          <MenuItem key={item._id} value={item._id}>
            {item.icon
            && <>
              <IconField iconName={item.icon as InventoryCategoryIconName} source={item.icon} />
              <span style={{ marginLeft: '10px' }}></span>
            </>
            }
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );

};
